import type { Role, UserStatus } from "@/contracts";

import type { Tone } from "@/components/ui/badge";
import i18n from "@/i18n";

/**
 * User vocabulary in one place, the way `device-labels.ts` holds the device
 * one. Both the members table and the layout header read from here, so a
 * role is never spelled two different ways in the same session.
 */
export const ROLE_LABELS: Record<Role, string> = {
  get USER() {
    return i18n.t("pages:role.USER");
  },
  get ADMIN() {
    return i18n.t("pages:role.ADMIN");
  },
  get SUPER_ADMIN() {
    return i18n.t("pages:role.SUPER_ADMIN");
  },
};

function userStatusPresentation(
  labelKey: `pages:userStatus.${UserStatus}`,
  tone: Tone,
  hintKey: `pages:userStatusHint.${UserStatus}`,
): { label: string; tone: Tone; hint: string } {
  return {
    label: i18n.t(labelKey),
    tone,
    hint: i18n.t(hintKey),
  };
}

export const USER_STATUS: Record<UserStatus, { label: string; tone: Tone; hint: string }> = {
  get ACTIVE() {
    return userStatusPresentation("pages:userStatus.ACTIVE", "ok", "pages:userStatusHint.ACTIVE");
  },
  get INVITED() {
    return userStatusPresentation("pages:userStatus.INVITED", "info", "pages:userStatusHint.INVITED");
  },
  get DISABLED() {
    return userStatusPresentation(
      "pages:userStatus.DISABLED",
      "neutral",
      "pages:userStatusHint.DISABLED",
    );
  },
};
